<template>
  <div class="dettaglio-buono">

    <div class="header-tab col-24 no-padding row row-custom">
      <div class="my-label col-24 no-padding">
        {{ (buono.numBuono !== '') ? ('' + $t('dettaglioBuono.buono').toUpperCase() + ' ' + buono.numBuono + ' ') : '' }}
    </div>
      <div class="sotto-label col-24 no-padding">
        {{ (buono.numBuono !== '') ? ('(' + $t('dettaglioBuono.del') + ' ' + buono.datBuono+')') : '' }}
      </div>
    </div>


    <div class="stepper col-24 no-padding">
      <el-steps ref="steps" :active="stepActive" :align-center="true">
        <el-step :title="$t('dettaglioBuono.trasporto').toUpperCase()" @click.native="setStepActive(0)">
          <i slot="icon">
            <icon name="riv-trasporto" scale="1.7"></icon>
          </i>
        </el-step>
        <el-step :title="$t('dettaglioBuono.protocolliSicurezza').toUpperCase()" @click.native="setStepActive(1)">
          <i slot="icon">
            <icon name="riv-protocollo" scale="1.4"></icon>
          </i>
        </el-step>
        <el-step :title="$t('dettaglioBuono.prodotti').toUpperCase()" @click.native="setStepActive(2)">
          <i slot="icon">
            <icon name="riv-prods" scale="1.5"></icon>
          </i>
        </el-step>
        <el-step :title="$t('dettaglioBuono.riepilogo').toUpperCase()">
          <i slot="icon">
            <icon name="riv-riepilogo" scale="1.4"></icon>
          </i>
        </el-step>
      </el-steps>
    </div>

    <trasporto v-if="(stepActive === 0)" :conf="conf" :buono="buono" :form="form" :saved="riepilogo.step_0" @avanti="avanti"></trasporto>
    <protocolli-sicurezza v-if="(stepActive === 1)" :form="form" :saved="riepilogo.step_1" @avanti="avanti" @indietro="indietro"></protocolli-sicurezza>
    <prodotti v-if="(stepActive === 2)" :saved="riepilogo.step_2" :form="form" :conf="conf" :buono="buono" @avanti="avanti" @indietro="indietro"></prodotti>
    <riepilogo v-if="(stepActive === 3)" :form="form" :conf="conf" :saved="riepilogo" :buono="buono" :buonoAttrib="buonoAttrib" :buonoData="buonoData" @indietro="indietro"></riepilogo>

  </div>
</template>

<script>
  import Trasporto from '@/components/Rottame/WebGestioneRottame/Trasporto'
  import ProtocolliSicurezza from '@/components/Rottame/WebGestioneRottame/ProtocolliSicurezza'
  import Prodotti from '@/components/Rottame/WebGestioneRottame/Prodotti'
  import Riepilogo from '@/components/Rottame/WebGestioneRottame/Riepilogo'

  export default {
    name: 'DettaglioBuono',
    components: {Trasporto, ProtocolliSicurezza, Prodotti, Riepilogo},
    data () {
      return {
        stepActive: 0,
        buono: {
          numBuono: ''
        },
        form: {
          stab: {
            descStab: ''
          }
        },
        conf: {
          modoTrasp: '',
          numConf: ''
        },
        buonoAttrib: {},
        buonoData: [],
        riepilogo: {
          step_0: {
            ordNave: {},
            loc: {},
            subFor: {},
            spedizioniere: {}
          },
          step_1: {},
          step_2: {}
        },
        codLang: sessionStorage.getItem('codLang')
      }
    },
    i18n: {
      messages: {
        it_IT: {
          dettaglioBuono: {
            numBuono: 'Nr. Buono',
            del: 'del',
            trasporto: 'Trasporto',
            protocolliSicurezza: 'Protocolli sicurezza',
            prodotti: 'Prodotti',
            riepilogo: 'Riepilogo',
            buono: 'Buono'
          }
        },
        fr_FR: {
          dettaglioBuono: {
            numBuono: 'Nr. Bon',
            del: 'de',
            trasporto: 'Transport',
            protocolliSicurezza: 'Protocoles de sécurité',
            prodotti: 'Produits',
            riepilogo: 'Résumé',
            buono: 'Bon'
          }
        },
        es_ES: {
          dettaglioBuono: {
            numBuono: 'Nr. Vale',
            del: 'del',
            trasporto: 'Transporte',
            protocolliSicurezza: 'Protocolos de seguridad',
            prodotti: 'Productos',
            riepilogo: 'Resumen',
            buono: 'Vale'
          }
        },
        de_DE: {
          dettaglioBuono: {
            numBuono: 'Nr. Schein',
            del: 'des',
            trasporto: 'Transport',
            protocolliSicurezza: 'Sicherheitsprotokolle',
            prodotti: 'Produkte',
            riepilogo: 'Zusammenfassung',
            buono: 'Schein'
          }
        },
        en_GB: {
          dettaglioBuono: {
            numBuono: 'Nr. Pass',
            del: 'of',
            trasporto: 'Transport',
            protocolliSicurezza: 'Security protocols',
            prodotti: 'Products',
            riepilogo: 'Summary',
            buono: 'Pass'
          }
        }
      }
    },
    /*
    mounted: function () {
      this.initialize()
    },
    */
    activated: function () {
      this.initialize()
    },
    deactivated: function () {
      this.resetDati()
    },
    methods: {
      openSearch: function () {
        this.$emit('openSearch')
      },
      resetDati: function () {
        this.$set(this, 'stepActive', 0)
        let buono = {
          numBuono: ''
        }
        let form = {
          stab: {
            descStab: ''
          }
        }
        this.$set(this, 'buono', buono)
        this.$set(this, 'form', form)
        let conf = {
          modoTrasp: '',
          numConf: ''
        }
        this.$set(this, 'conf', conf)
        this.$set(this, 'buonoAttrib', {})
        this.$set(this, 'buonoData', [])
        let riepilogo = {
          step_0: {
            ordNave: {},
            loc: {},
            subFor: {},
            spedizioniere: {}
          },
          step_1: {},
          step_2: {}
        }
        this.$set(this, 'riepilogo', riepilogo)
      },
      initialize: function () {
        this.$set(this, 'form', (sessionStorage.hasOwnProperty('WGR_form')) ? (JSON.parse(sessionStorage.getItem('WGR_form'))) : null)
        this.$set(this, 'buono', (sessionStorage.hasOwnProperty('WGR_buono')) ? (JSON.parse(sessionStorage.getItem('WGR_buono'))) : (this.buono))
        this.$set(this, 'conf', (sessionStorage.hasOwnProperty('WGR_conf')) ? (JSON.parse(sessionStorage.getItem('WGR_conf'))) : (this.conf))
        if ((this.form === null)) {
          this.$router.push('/rottame/gestionerottame/conferme')
        } else {
          this.loadBuono()
        }
      },
      setStepActive: function (num) {
        if (num <= this.stepActive) {
          this.stepActive = num
        }
      },
      avanti: function (step, objSaved) {
        if (step === 0) {
          this.riepilogo.step_0 = objSaved
        } else if (step === 1) {
          this.riepilogo.step_1 = objSaved
        } else if (step === 2) {
          this.riepilogo.step_2 = objSaved
        }
        this.stepActive++
      },
      indietro: function () {
        this.stepActive--
      },
      back: function () {
        this.$router.push({name: 'GestioneRottameElencoBuoni'})
      },
      loadBuono: function () {
        this.$http.get('buonidiscarico/buono', {
          params: {
            codLang: this.codLang,
            country: this.form.country,
            modoTrasp: this.conf.modoTrasp,
            numBuono: this.buono.numBuono,
            codStab: this.form.stab.codStab,
            numConf: this.conf.numConf,
            codSoc: this.form.stab.codSoc,
            codForn: this.form.fornitore.codForn,
            tipoForn: this.form.fornitore.tipForn
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              if (!sessionStorage.hasOwnProperty('WGR_conf')) {
                this.$set(this.conf, 'modoTrasp', response.body.attrib.modoTrasp)
                this.$set(this.conf, 'numConf', response.body.attrib.numConf)
                this.$set(this.conf, 'datConsDa', response.body.attrib.datConsDa)
                this.$set(this.conf, 'datConsA', response.body.attrib.datConsA)
                sessionStorage.setItem('WGR_conf', JSON.stringify(this.conf))
              } else {
                let conf = JSON.parse(sessionStorage.getItem('WGR_conf'))
                conf.numConf = response.body.attrib.numConf
                conf.modoTrasp = response.body.attrib.modoTrasp
                sessionStorage.setItem('WGR_conf', JSON.stringify(conf))
              }
              let attrib = response.body.attrib
              this.riepilogo = {
                step_0: {
                  letVettura: (attrib.letVettura !== undefined) ? attrib.letVettura : '',
                  dataLVettura: (attrib.dataLVettura !== undefined) ? attrib.dataLVettura : '',
                  dataArrivo: attrib.datArrivo,
                  dataSpedizione: attrib.datSped,
                  ordNave: {
                    annoOrdNave: attrib.annoOrdNave,
                    numOrdNave: attrib.numOrdNave
                  },
                  loc: {
                    codLoca: attrib.codLocalita,
                    desLoca: attrib.desLocalita,
                    poiSO: attrib.poiSO,
                    poiPR: attrib.poiPR
                  },
                  nomeAutista: attrib.nomeAutista,
                  numDdt: attrib.numDdt,
                  spedizioniere: {
                    codSpediz: attrib.codSpediz,
                    desSpediz: attrib.desSpediz,
                    codTRS: attrib.codTRS
                  },
                  UNI_TRASP_ROT: attrib.UNI_TRASP_ROT,
                  subFor: {
                    codSubfor: attrib.codSubfor,
                    desSubfor: attrib.desSubfor
                  },
                  targaMotrice: attrib.targaMot,
                  targaRimorchio: attrib.targaRim,
                  numVagone: attrib.numVagone,
                  ragSocTrasp: attrib.ragSocTrasp,
                  indirTrasp: attrib.indirTrasp,
                  capTrasp: attrib.capTrasp,
                  localTrasp: attrib.localTrasp,
                  paIvaTrasp: attrib.paIvaTrasp,
                  nPatente: attrib.nPatente,
                  fir_1: attrib.fir.split(' ')[0] || '',
                  fir_2: attrib.fir.split(' ')[1] || '',
                  fir_3: attrib.fir.split(' ')[2] || '',
                  ifFir: attrib.ifFir,
                  spedizTxt: attrib.spedizTxt,
                  ifRifiuto: attrib.ifRifiuto,
                  ROT_SLOT_RULES: attrib.ROT_SLOT_RULES,
                  numBuono: this.buono.numBuono,
                  slot: attrib.codeSlot
                },
                step_1: {
                  protSicur: attrib.protSicur,
                  ifProtSic: attrib.ifProtSic
                },
                step_2: {
                  prodotti: response.body.data,
                  qtaTot: attrib.qtaTot,
                  ifRifiuto: attrib.ifRifiuto
                }
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
              this.$router.push({name: 'GestioneRottameElencoBuoni'})
            }
          })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../assets/less/general.less";

  .dettaglio-buono {
    overflow-y: auto;
    overflow-x: hidden;
   .header-tab {
      height: 70px;
      text-align: center;
      margin-bottom: 5px;
      .my-label {
        line-height: 55px;
        height: 45px;
        .set-font(@color: @oroRiva; @size: 22px; @family: 'os-semibolditalic');
        letter-spacing: 2px;
      }
      .sotto-label {
        .set-font(@size: 15px; @family: 'os-lightitalic');
        letter-spacing: 1px;
        height: 25px;
      }
    }
    .stepper {
      margin-top: 20px;
      margin-bottom: 50px;
      .el-steps {
        margin: auto;
        height: 70px;
        .el-step {
          .el-step__line-inner {
            border: none;
          }
          .el-step__title {
            line-height: 12px;
            margin-top: 10px;
            letter-spacing: 1px;
            text-transform: uppercase;
            .set-font(@size: 11px; @weight: normal; @color: @greenRiva);
          }
          .el-step__title.is-process {
            .set-font(@size: 11px; @family: 'os-semibold');
          }
          .el-step__title.is-finish {
            .set-font(@size: 11px; @family: 'os-semibold');
          }
          .is-finish {
            .el-step__icon.is-text {
              border-radius: 50%;
              border: 0px;
              background-color: @stepperFinish;
              height: 45px;
              width: 45px;
              box-shadow: 2px 2px 5px #777777;
              -webkit-box-shadow: 2px 2px 5px #777777;
              line-height: 0px;
              color: @white;
            }
          }
          .is-process {
            .el-step__icon.is-text {
              border-radius: 50%;
              border: 0px;
              background-color: @stepperProcess;
              height: 45px;
              width: 45px;
              box-shadow: 2px 2px 5px #777777;
              -webkit-box-shadow: 2px 2px 5px #777777;
              line-height: 0px;
              color: @white;
            }
          }
          .is-wait {
            .el-step__icon.is-text {
              border-radius: 50%;
              border: 0px;
              background-color: @stepperWait;
              height: 45px;
              width: 45px;
              line-height: 0px;
              color: @white;
            }
          }
          .is-wait:hover {
            cursor: not-allowed;
          }
        }
        .el-step.is-horizontal .el-step__line {
          top: 23px;
          height: 1px;
        }
        .el-step:hover {
          cursor: pointer;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Rottame/WebGestioneRottame/DettaglioBuono.vue